export enum ConsentCategory {
    Strict = 'strict',
    Targeting = 'targeting',
    Performance = 'performance',
    Functionality = 'functionality'
}
